import { Business } from '@/types/homepage';
import { apiClient } from './apiClient';

interface MapBounds {
  northEast: { lat: number; lng: number };
  southWest: { lat: number; lng: number };
}

interface BusinessesResponse {
  success: boolean;
  businesses: Business[];
  businessCount: number;
}

// Queue to manage concurrent API calls
let currentFetchPromise: Promise<BusinessesResponse> | null = null;

export const homepageApi = {
  getBusinessesInBounds: async (bounds: MapBounds): Promise<BusinessesResponse> => {
    // If there's already a fetch in progress, wait for it
    if (currentFetchPromise) {
      console.debug('[homepageApi] Using queued fetch for businesses in bounds');
      const response = await currentFetchPromise;
      return response;
    }

    console.debug('[homepageApi] Processing queued fetch for businesses in bounds');

    try {
      // Create the promise and store it
      currentFetchPromise = apiClient.post<BusinessesResponse>('/api/businesses/search', {
        bounds,
        limit: 50 // Adjust this based on your needs
      });

      // Wait for the response
      const response = await currentFetchPromise;
      return response;
    } finally {
      // Clear the promise once it's done (success or failure)
      currentFetchPromise = null;
    }
  }
}; 